import { IAccount } from "src/types";

export const hasWlpBranding = (account?: IAccount | null) =>
  Boolean(account?.primary_color || account?.footer || account?.footer_url)
